<template>
  <div class="process_wrap">
    <CommonHead title="登记接种"></CommonHead>
    <div class="content">
      <div class="lineup">
        <van-icon name="clock-o" size="26" color="#50A0FF" />
        <div class="linetop" v-for="(item,index) in vaccinateQueueList" :key="index">
          <div class="linedsc">等待<span>{{ item.waitNumber || 0 }}</span>人，预计等待<span> {{ item.waitTime || 0 }} </span>分钟</div>
          <div class="user_info">
            <span> {{ datas.profileName }} </span> <span> {{ item.queueNo }} </span>
          </div>
          <div class="vaccname"><span v-for="(item,index) in vaccineList" :key="index"> {{item}} </span></div>
        </div>
      </div>
      <div class="processmain">
        <van-collapse v-model="activeNames" accordion>
          <van-steps direction="vertical" :active="stepActive" active-icon="checked" finish-icon="checked" active-color="#50A0FF">
            <van-step>
              <van-collapse-item :border="false" :name="0" :disabled="openDiableCollapse && stepActive != -1">
                <template #title>
                  <div class="process-title" :class="{ acticeColor: stepActive >= -1 }">
                    <span>自助预检</span>
                  </div>
                </template>
                <div class="card">
                  <van-button round color="#50A0FF" block :disabled="stepActive != -1" @click="navigate('/preview', -1)">
                    {{stepActive >= 0 ? '预检已完成' : '立即预检'}}
                  </van-button>
                </div>
              </van-collapse-item>
            </van-step>
            <van-step>
              <van-collapse-item :border="false" :name="1" :disabled="openDiableCollapse && stepActive != 0">
                <template #title>
                  <div class="process-title" :class="{ acticeColor: stepActive >= 0 }">
                    <span>告知书签字</span>
                  </div>
                </template>
                <div class="card">
                  <van-button round color="#50A0FF" block :disabled="stepActive != 0" @click="navigate('/signature', 0)">
                    {{stepActive >= 1 ? '签字已完成' : '立即签字'}}
                  </van-button>
                </div>
              </van-collapse-item>
            </van-step>
            <van-step>
              <van-collapse-item :border="false" :name="2" :disabled="openDiableCollapse && stepActive != 1">
                <template #title>
                  <div class="process-title" :class="{ acticeColor: stepActive >= 1 }">
                    <span>医生确认</span>
                  </div>
                </template>
                <div class="card qrcode-card">
                  <barcode
                      :value="profileQrCode"
                      :display-value="true"
                      height="60"
                      width="1"
                      text-align="center"
                      font-size="14px"
                  >
                    条形码加载失败
                  </barcode>
                  <qrcode
                      :value="profileQrCode"
                      :options="{ height: 196, width: 196, scale: 4, small: true, margin: 1 }"
                  ></qrcode>
                  <p>出示二维码或持身份证至登记台登记</p>
                </div>
              </van-collapse-item>
            </van-step>
            <van-step>
              <van-collapse-item :border="false" :name="3" :disabled="openDiableCollapse && stepActive != 2">
                <template #title>
                  <div class="process-title" :class="{ acticeColor: stepActive >= 2 }">
                    <span>疫苗接种</span>
                  </div>
                </template>
                <div class="card vaccination" v-for="(it,idx) in vaccinateQueueList" :key="it.queueNo">
                  <p> {{it.vaccineName}}</p>
                  <div class="nationlist">
                    <div class="natitem">
                      <van-image class="vanimg" width="23px"height="21px" :src="require('@/assets/user/paihao.png')"/>
                      <p class="natimy">我的排号</p>
                      <p class="natnumber"> {{ it.queueNo }} </p>
                    </div>
                    <div class="natitem">
                      <van-image class="vanimg" width="23px"height="21px" :src="require('@/assets/user/deng.png')"/>
                      <p class="natimy">等候人数</p>
                      <p class="natnumber"> {{ it.waitNumber }} </p>
                    </div>
                  </div>
                </div>

              </van-collapse-item>
            </van-step>
            <van-step>
              <van-collapse-item :border="false" :name="4" :disabled="openDiableCollapse && stepActive != 3">
                <template #title>
                  <div class="process-title" :class="{ acticeColor: stepActive >= 3 }">
                    <span>安全性观察</span>
                  </div>
                </template>
                <div class="card">
                  <van-divider dashed v-if="times != 0">留观倒计时</van-divider>
                  <div class="vancount" v-if="times != 0">
                    <van-count-down :time="times" @finish="finish">
                      <template #default="timeData">
                        <span class="block">{{ timeData.minutes }}</span>
                        <span class="colon">分</span>
                        <span class="block">{{ timeData.seconds }}</span>
                        <span class="colon">秒</span>
                      </template>
                    </van-count-down>
                    <van-divider :style="{ color: 'rgba(0, 0, 0, 0.25)', borderColor: '#fff', margin: '5px 0px' }" >
                      留观30分钟后方可离开
                    </van-divider>
                  </div>
                  <div class="safety">
                    <van-button round color="#50A0FF" plain hairline block size="small" :disabled="stepActive != 3" @click="navigate('/preview', 3)">
                      {{'安全性观察'}}
                    </van-button>
                    <van-button round color="#50A0FF" block size="small" :disabled="stepActive != 3" @click="navigate('/preview', 3)">
                      {{'立即评价'}}
                    </van-button>
                  </div>

                </div>
              </van-collapse-item>
            </van-step>


          </van-steps>

        </van-collapse>

      </div>
      <div class="flush" @click="toggleRotate()">
        <van-image :class="['vanimg',{rotate: isRotate}]" width="13px"height="15px" :src="require('@/assets/user/shuaxin.png')"/>
        <span>立即刷新</span>
      </div>
    </div>
    <div class="fill-iphone-safe-area"></div>

  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import { Toast } from 'vant'
import VueBarcode from 'vue-barcode'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { checkVaccinateProcess } from '@/api/register'
import moment from 'moment'
import { resetData,debounce } from '@/utils/index'
export default {
  name:'Process',
  components: {
    CommonHead,
    barcode: VueBarcode,
    qrcode: VueQrcode
  },
  data() {
    return {
      activeNames: -1, // 流程
      stepActive: -1, // 完成步骤
      times: 0,  // 留观时间
      dialogShow: false,  // 留观提醒
      timer: null,  // 定时器
      openDiableCollapse: true, // 是开启禁用面包屑
      processId: '', // 流程id
      profileQrCode: '', // 二维码
      reservationIds: '',
      datas: {}, // 接种者信息
      vaccineList: [], // 疫苗
      vaccinateQueueList: [], // 排号信息
      processTimer: null,
      isRotate: false,

    }
  },
  watch: {
    activeNames:{
      handler(newVal,oldVal) {
        let that = this;
        console.log('activeNames ==>' + newVal);
        if (newVal == 2) {
          that.timer = setInterval(() => {
            that.getVaccinateInfo(true);
          }, 6000);
        }
        if (newVal > 3 ) {
          clearInterval(that.timer)
          this.timer = null
        }
        if (newVal == 4) {
          clearInterval(that.timer)
          that.timer = null;
          clearInterval(that.processTimer)
          that.processTimer = null
          if (that.dialogShow) {
            that.showObserveTips()
          }
        }
        if (newVal == 5) {
          that.dialogShow = true;
        }
      },
      deep:true, // 深度监听
      immediate: true // 使监听在页面加载完成后执行，避免数据无变化或初进页面时监听不执行
    }
  },
  created() {
    this.processId = this.$route.query.processId;
    this.$nextTick(() => {
      this.getVaccinateInfo(true);
      // this.intervalGetVaccinateProcess();
    })
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
    clearInterval(this.processTimer)
    this.processTimer = null
  },
  methods: {
    // 留观提醒
    showObserveTips() {
      this.$dialog.alert({
        title: '留观提醒',
        message: '您已接种完成，请按要求进行留院观察，留观结束后可离开医院。',
        confirmButtonText: '确定'
      })
    },
    //
    intervalGetVaccinateProcess() {
      var _this = this
      this.processTimer = setInterval(() => {
        _this.getVaccinateInfo(true)
      }, 60000)
    },
    // 获取流程
    async getVaccinateInfo(hideLoading) {
      try {
        const {code , data} = await checkVaccinateProcess({processId: this.processId},{ hideLoading: hideLoading })
        if (code == 0) {
          this.datas = data.checkIn;
          this.vaccineList = data.vaccineList;
          this.vaccinateQueueList = data.vaccinateQueueList;
          this.profileQrCode = data.profileQrCode;
          // 为什么减一. 画页面的时候, 前端默认从 0 开始了,后端 从 1 开始, 完成状态是需要减 2
          if (parseInt(data.checkIn.status) < 4) {
            this.stepActive = data.checkIn.status - 2; //
            this.activeNames = data.checkIn.status - 1; //
          } else {
            this.stepActive = data.checkIn.status - 3; //
            this.activeNames = (data.checkIn.status - 2); //
          }
          this.reservationIds = data.checkIn.reservationIds
          if (!data.checkIn.vaccinateTime) {
            this.times = 0
            this.dialogShow = false
            return
          }
          // 在指定接种 时间、日期基础上加30分钟，得到新的时间
          const timeDiff = data.timeDiff
          if (timeDiff > 0) {
            this.times = timeDiff * 1000
            this.dialogShow = true;
          }

        }

      } catch (error) {

      }
    },

    goBack() {
      this.$router.go(-1)
    },
    navigate(url, step) {
      if (this.stepActive >= step) {
        // if (step === 2) {
        //   localStorage.setItem('list', JSON.stringify(this.payList))
        // }
        if (step == 3) {
          Toast.fail('功能开发中')
          return
        }
        return this.$router.push({ path: url, query: { processId: this.processId }})
      }
      Toast.fail('请按照顺序完成相关步骤')
    },
    // 给刷新加上防抖(防止点击一直刷新/刷新当前流程)
    toggleRotate: debounce(
        function() {
          this.isRotate = !this.isRotate
          resetData(this, 'payList')
          resetData(this, 'vaccineList')
          resetData(this, 'vaccinateQueueList')
          resetData(this, 'stepActive')
          resetData(this, 'activeNames')
          this.getVaccinateInfo(false)
          setTimeout(() => {
            this.isRotate = false
          }, 1000)
        },
        500,
        true
    ),
    finish() {
      this.stepActive = 3;
      this.activeNames = -1;
      this.dialogShow = false;
      setTimeout(() => {
        this.getVaccinateInfo(true);
      },500)
    }

  }
}
</script>
<style lang="less" scoped>
.process_wrap {
  background-color: #F6F8FA;

  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 14px;

    .lineup {
      width: 100%;
      box-sizing: border-box;
      border-bottom: 1px dashed #F6F8FA;
      background-color: #FFFFFF;
      padding: 20px 14px 5px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .linetop {
        padding-left: 9px;
        .linedsc {
          font-size: 15px;
          color: #333333;
          padding-bottom: 30px;

          span {
            font-size: 23px;
            color: #50A0FF;
            margin: 0 5px;
          }
        }
        .user_info {
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          span {
            margin-right: 10px;
          }
        }
        .vaccname {
          padding: 20px 0;
          font-size: 12px;
          color: #666666;
        }

      }

    }
    .processmain {
      padding: 10px 14px 5px;
      background-color: #FFFFFF;
    }

    .safety {
      width: 100%;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 50% 50%;
      column-gap: 10px;
      margin-top: 20px;
    }
    .process-title {
      font-size: 15px;
      color: rgba(0, 0, 0, 0.65);
    }
    .acticeColor {
      color: #50A0FF;
      //font-weight: bold;
    }
    .qrcode-card {
      background: #FFFFFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        font-size: 12px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .vaccination {
      padding-left: 10px;
      p {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        padding: 12px 0;
      }

      .nationlist {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .natitem {
          width: 90px;
          padding: 13px 0 8px;
          border: 1px solid #50A0FF;
          border-radius: 10px;
          margin-right: 16px;
          text-align: center;

          .natimy {
            color: #999999;
            font-size: 12px;
            padding: 9px 0;
          }
          .natnumber {
            font-size: 15px;
            color: #50A0FF;
            font-weight: bold;
            padding: 0;
          }
        }

      }

    }
    .vancount {
      text-align: center;

      .colon {
        display: inline-block;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.65);
        padding: 0 5px;
      }
      .block {
        display: inline-block;
        font-size: 20px;
        color: #FF5383;
        font-weight: bold;
        width: 40px;
        padding: 8px 0;
        background: #EBEDEF;
        border-radius: 5px;
        text-align: center;
      }
    }

    ::v-deep {
      .van-step--vertical {
        padding-top: 0px !important;

      }
    }

    .flush {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      font-size: 16px;
      color: #50A0FF;
      span {
        margin-left: 10px;
      }
    }

  }
  .rotate {
    transition: transform 0.3s ease;
    transform: rotate(360deg);
  }










}


</style>